var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.myrender) ? _c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "overflow-y": "scroll",
      "height": "500px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.datiAnagraficiClienteLbl))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "border-top": "1px solid lightgray",
      "content": "''",
      "top": "20px",
      "right": "10em",
      "vertical-align": "top",
      "bottom": "0",
      "width": "100%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.ragioneSocialeLbl))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ragioneSocialeValue),
      expression: "ragioneSocialeValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "disabled": "",
      "type": "text",
      "id": "ragioneSocialeId"
    },
    domProps: {
      "value": (_vm.ragioneSocialeValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ragioneSocialeValue = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.codiceFiscaleLbl))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.codiceFiscValue),
      expression: "codiceFiscValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "disabled": "",
      "type": "text",
      "id": "codiceFiscValueId"
    },
    domProps: {
      "value": (_vm.codiceFiscValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.codiceFiscValue = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.partitaIvaLbl))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.partitaIvaValue),
      expression: "partitaIvaValue",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "disabled": "",
      "type": "number",
      "id": "partitaIvaId"
    },
    domProps: {
      "value": (_vm.partitaIvaValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.partitaIvaValue = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.nomeTitolareLbl))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nomeTitolareValue),
      expression: "nomeTitolareValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "disabled": "",
      "type": "text",
      "id": "nomeTitolareId"
    },
    domProps: {
      "value": (_vm.nomeTitolareValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nomeTitolareValue = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.indirizzoDittaLbl))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.indirizzoDittaValue),
      expression: "indirizzoDittaValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "disabled": "",
      "type": "text",
      "id": "indirizzoDittaId"
    },
    domProps: {
      "value": (_vm.indirizzoDittaValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.indirizzoDittaValue = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.capLbl))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.capValue),
      expression: "capValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "disabled": "",
      "type": "text",
      "id": "capId"
    },
    domProps: {
      "value": (_vm.capValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.capValue = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.localitaLbl))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localitaValue),
      expression: "localitaValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "disabled": "",
      "type": "text",
      "id": "localitaId"
    },
    domProps: {
      "value": (_vm.localitaValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.localitaValue = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.provinciaLbl))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.provinciaValue),
      expression: "provinciaValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "disabled": "",
      "type": "text",
      "id": "provinciaId"
    },
    domProps: {
      "value": (_vm.provinciaValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.provinciaValue = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.nazioneLbl))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nazioneValue),
      expression: "nazioneValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "disabled": "",
      "type": "text",
      "id": "nazioneId"
    },
    domProps: {
      "value": (_vm.nazioneValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nazioneValue = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.telefonoLbl))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telefonoValue),
      expression: "telefonoValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "disabled": "",
      "type": "text",
      "id": "televonoId"
    },
    domProps: {
      "value": (_vm.telefonoValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.telefonoValue = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.faxLbl))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.faxValue),
      expression: "faxValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "disabled": "",
      "type": "text",
      "id": "faxId"
    },
    domProps: {
      "value": (_vm.faxValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.faxValue = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.mailLbl))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mailValue),
      expression: "mailValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "disabled": "",
      "type": "text",
      "id": "mailId"
    },
    domProps: {
      "value": (_vm.mailValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mailValue = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', [_c('label', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.consegnaLbl))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "border-top": "1px solid lightgray",
      "content": "''",
      "top": "20px",
      "right": "10em",
      "vertical-align": "top",
      "bottom": "0",
      "width": "100%"
    }
  }), _vm._v(" "), (_vm.showReqDeliveryDate) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.dataConsegnaRichiestaLbl))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('datepicker', {
    staticStyle: {
      "padding": "0px",
      "color": "black",
      "height": "26px",
      "width": "150px"
    },
    attrs: {
      "open-date": _vm.openDate,
      "disabledDates": _vm.disabledDates,
      "id": "dataConsegnaRichiestaId",
      "full-month-name": true,
      "clear-button": true,
      "placeholder": _vm.$Jed.firstUpperTranslate('select') + ' ' + _vm.$Jed.translate('date'),
      "format": "dd / MM / yyyy",
      "language": _vm.datePickLang
    },
    model: {
      value: (_vm.dataConsegnaRichiestaValue),
      callback: function($$v) {
        _vm.dataConsegnaRichiestaValue = $$v
      },
      expression: "dataConsegnaRichiestaValue"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!_vm.hidePortType) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.tipoPortoLbl))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('v-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "type",
      "options": _vm.portTypesList,
      "placeholder": _vm.$Jed.firstUpperTranslate('select') + ' ' + _vm.$Jed.translate('port type')
    },
    on: {
      "input": function($event) {
        _vm.onPortTypeinput($event)
      }
    },
    model: {
      value: (_vm.portTypeValue),
      callback: function($$v) {
        _vm.portTypeValue = $$v
      },
      expression: "portTypeValue"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.indirizzoSpedizioneLbl))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('cfg', {
    staticClass: "col-sm-9",
    attrs: {
      "cid": "shopCart2.chooseAddress",
      "tag": "div"
    },
    on: {
      "click": function($event) {
        !_vm.disableAddressChoice ? _vm.showTip() : null
      }
    }
  }, [_c('v-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "type",
      "options": _vm.addressesList,
      "tagStyle": {
        'width': '85%',
        'white-space': 'nowrap',
        'overflow': 'hidden',
        'text-overflow': 'ellipsis'
      },
      "disabled": _vm.disableAddressChoice,
      "placeholder": _vm.$Jed.firstUpperTranslate('select') + ' ' + _vm.$Jed.translate('address')
    },
    on: {
      "input": function($event) {
        _vm.onShipAddressInput()
      }
    },
    model: {
      value: (_vm.addressValue),
      callback: function($$v) {
        _vm.addressValue = $$v
      },
      expression: "addressValue"
    }
  })], 1), _vm._v(" "), (_vm.enableAddAddress) ? _c('cfg', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "cid": "shopCart2.addAddress",
      "tag": "div"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addAddressClick($event)
      }
    }
  }, [_c('i', {
    class: _vm.$root.icons.plus,
    staticStyle: {
      "font-size": "1.8em"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.enableAddAddress && _vm.addressChosen && (_vm.addressValue && !_vm.addressValue.obj.pid)) ? _c('cfg', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "cid": "shopCart2.editAddress",
      "tag": "div"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.modifyAddressClick($event)
      }
    }
  }, [_c('i', {
    class: _vm.$root.icons.edit,
    staticStyle: {
      "font-size": "1.8em"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.enableAddAddress && _vm.addressChosen && (_vm.addressValue && !_vm.addressValue.obj.pid)) ? _c('cfg', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "cid": "shopCart2.deleteAddress",
      "tag": "div"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.delAddressClick($event)
      }
    }
  }, [_c('i', {
    class: _vm.$root.icons.close,
    staticStyle: {
      "font-size": "1.8em"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e()], 1)])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "height": "70px"
    }
  }, [_c('div', {
    staticClass: "col-sm-5 text-left"
  }, [(_vm.addressChosen) ? _c('label', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.riepilogoIndirizzoLbl))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('div', [_vm._v(_vm._s(_vm.nominativoSped))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.indirizzoSped))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.capSped) + " " + _vm._s(_vm.localitaSped) + " " + _vm._s(_vm.sigPro))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.nazioneSped))])])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('cfg', {
    attrs: {
      "cid": "shopCart2.shippingTypeArea",
      "tag": "div"
    }
  }, [_c('label', {
    staticClass: "text-left",
    staticStyle: {
      "vertical-align": "bottom"
    }
  }, [_vm._v(_vm._s(_vm.spedizioneLbl))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "border-top": "1px solid lightgray",
      "content": "''",
      "top": "20px",
      "right": "10em",
      "vertical-align": "top",
      "bottom": "0",
      "width": "100%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.tipoSpedizioneLbl))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('v-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "type",
      "options": _vm.shippingTypesList,
      "disabled": _vm.disableShippingChoice,
      "placeholder": _vm.$Jed.firstUpperTranslate('select') + ' ' + _vm.$Jed.translate('Tipo Spedizione')
    },
    model: {
      value: (_vm.shippingTypeValue),
      callback: function($$v) {
        _vm.shippingTypeValue = $$v
      },
      expression: "shippingTypeValue"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.accorpaSpedizioneLbl))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accorpaSpedizioneValue),
      expression: "accorpaSpedizioneValue"
    }],
    staticStyle: {
      "display": "inline-block",
      "position": "relative",
      "width": "20px",
      "height": "20px"
    },
    attrs: {
      "type": "checkbox",
      "disabled": _vm.disableShippingChoice
    },
    domProps: {
      "checked": Array.isArray(_vm.accorpaSpedizioneValue) ? _vm._i(_vm.accorpaSpedizioneValue, null) > -1 : (_vm.accorpaSpedizioneValue)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.accorpaSpedizioneValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accorpaSpedizioneValue = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accorpaSpedizioneValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.accorpaSpedizioneValue = $$c
        }
      }
    }
  })])])])], 1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "controls col-sm-3"
  }, [_c('button', {
    staticClass: "btn btn-primary-default",
    staticStyle: {
      "width": "130px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.previousClick($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.indietroBtnLbl))])]), _vm._v(" "), _c('div', {
    staticClass: "controls col-sm-3"
  }, [_c('button', {
    staticClass: "btn btn-primary-default",
    staticStyle: {
      "width": "130px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.forwardClick($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.avantiBtnLbl))])]), _vm._v(" "), _c('cfg', {
    attrs: {
      "cid": "shopCart.nuovoOrdineBtn",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "controls col-sm-3"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "width": "140px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cleanShopCartClick($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('new order')))])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  })]), _vm._v(" "), _vm._m(3)])]) : _c('div')
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(" ")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(" ")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md"
  }, [_vm._v(" ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md"
  }, [_vm._v(" ")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03b9f81a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/shopcart/ShopCart2.vue
// module id = 1670
// module chunks = 1